import React from "react";
import { motion } from "framer-motion";
import PowerfulIcon from "../assets/icons/Powerful Icon.png";
import BiodegradableIcon from "../assets/icons/Biodegradable Icon.png";
import ProvenIcon from "../assets/icons/Proven Icon.png";
import SqueakyIcon from "../assets/icons/Squeaky Clean Icon.png";
import { useLocation } from "react-router-dom";

const iconData = [
  { src: PowerfulIcon, label: "Powerful" },
  { src: BiodegradableIcon, label: "Biodegradable" },
  { src: ProvenIcon, label: "Proven" },
  { src: SqueakyIcon, label: "Squeaky Clean" },
];

const bezier = [0.4, 0, 0.2, 1];

const OurProductLine = () => {
  const location = useLocation();
  const isIndustrial = location.pathname.startsWith('/industrial');
  const isProductsPage = location.pathname === '/industrial/products' || location.pathname === '/household/products';
  const heroImageSrc = isIndustrial ? "/images/B2BProductGroupPhoto.png" : "/images/RRBottlesHeroImage.png";

  const renderHeroImage = () => (
    <motion.img
      src={heroImageSrc}
      alt="Product Line Hero"
      className="rounded-lg drop-shadow-lg w-full"
      initial={{ opacity: 0, y: 60 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: bezier, delay: 0.1 }}
      onError={() => console.error('[OurProductLine] Failed to load image:', heroImageSrc)}
      onLoad={() => console.log('[OurProductLine] Image loaded:', heroImageSrc)}
    />
  );

  return (
    <section className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={{}}
          className={`flex flex-col lg:flex-row items-center gap-4 lg:gap-12 ${!isProductsPage ? 'lg:mt-32' : ''}`}
        >
          {/* Image */}
          <motion.div
            className="w-full lg:w-1/2 max-w-[1800px]"
            initial={{ opacity: 0, x: isIndustrial ? 0 : -60, y: isIndustrial ? 60 : 0 }}
            whileInView={{ opacity: 1, x: 0, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: bezier, delay: 0.1 }}
          >
            {renderHeroImage()}
          </motion.div>

          {/* Content */}
          <div className="w-full lg:w-1/2">
            <motion.h2
              className="text-[#D3242A] text-4xl sm:text-5xl font-extrabold uppercase text-center lg:text-left mb-6"
              style={{ fontFamily: "Geogrotesque, sans-serif" }}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, ease: bezier, delay: 0.25 }}
            >
              OUR PRODUCT LINE
            </motion.h2>

            <motion.p
              className="text-black text-lg sm:text-xl leading-relaxed text-center lg:text-left mb-8"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, ease: bezier, delay: 0.4 }}
            >
              Discover a line of products crafted to tackle every challenge with professional-grade power. Designed with safety and sustainability in mind, RuggedRed delivers the clean you can trust.
            </motion.p>

            {/* Icons Grid */}
            <motion.div
              className="grid grid-cols-2 sm:grid-cols-4 gap-6 lg:gap-8"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={{}}
            >
              {iconData.map((icon, idx) => (
                <motion.div
                  key={idx}
                  className="flex flex-col items-center text-center"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, ease: bezier, delay: 0.55 + idx * 0.12 }}
                >
                  <img
                    src={icon.src}
                    alt={icon.label}
                    className="h-12 w-12 sm:h-16 sm:w-16 mb-2"
                  />
                  <p className="text-black text-sm sm:text-base font-semibold">
                    {icon.label}
                  </p>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default OurProductLine; 